import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../../../context/MyContext";
import "../../../../assets/css/seller/Auth/SellerAuthform.css";

const SellerLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { baseUrl, setAuthToken, setLoggedInSeller } =
    useContext(MyContext);
  const navigate = useNavigate();

  const autoLogin = (savedEmail, savedPassword) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", savedEmail);
    formdata.append("password", savedPassword);

    axios
      .post(`${baseUrl}/seller/auth/login`, formdata)
      .then((response) => {
        console.log(response.data);
        if (!response.data.token) {
          setLoading(false);
          localStorage.removeItem("sellerEmail");
          localStorage.removeItem("sellerPassword");
        } else {
          setLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          console.log(response.data.token);
          setLoggedInSeller(response.data.seller);
          localStorage.setItem(
            "sellerVerified",
            response.data.verified || "false",
          );
          navigate("/seller/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        localStorage.removeItem("sellerEmail");
        localStorage.removeItem("sellerPassword");
      });
  };

  const loginSeller = () => {
    setLoading(true);
    setErrorMessage("");
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/seller/auth/login`, formdata)
      .then((response) => {
        console.log(response.data);
        if (!response.data.token) {
          setErrorMessage("Invalid email or password");
          setLoading(false);
        } else {
          setLoading(false);
          localStorage.setItem("sellerEmail", email);
          localStorage.setItem("sellerPassword", password);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          console.log(response.data.token);
          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify(response.data.seller),
          );
          setLoggedInSeller(response.data.seller);
          localStorage.setItem(
            "sellerVerified",
            response.data.verified || "false",
          );

          navigate("/seller/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Login failed. Please check your credentials.");
        setLoading(false);
      });
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("sellerEmail");
    const savedPassword = localStorage.getItem("sellerPassword");
    console.log(savedEmail);
    console.log(savedPassword);
    if (savedEmail != null && savedEmail != "") {
      autoLogin(savedEmail, savedPassword);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="minimal-auth-wrapper">
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          />
          <p style={{ marginTop: "15px", fontSize: "18px" }}>
            Logging in you...
          </p>
        </div>
      ) : (
        <>
          <div className="doodle-background">
            <div className="doodle-pattern"></div>
          </div>

          <div className="minimal-auth-container">
            <div className="minimal-auth-card">
              <div className="auth-logo"></div>

              <div className="auth-header">
                <h1 className="auth-title">Seller Login</h1>
                <p className="auth-subtitle">
                  Don't have an account?{" "}
                  <Link to="/seller/register" className="auth-link">
                    Register here
                  </Link>
                </p>
              </div>

              <Form className="minimal-auth-form">
                <div className="authform-group-minimal">
                  <Form.Control
                    type="email"
                    placeholder="Work email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className="minimal-input"
                  />
                </div>

                <div className="authform-group-minimal">
                  <div className="password-input-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      className="minimal-input"
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="text-end mb-2">
                  <Link to="/seller/forgot-password" className="auth-link">
                    Forgot password?
                  </Link>
                </div>

                {errorMessage && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "0.875rem",
                      marginBottom: "1rem",
                      padding: "0.75rem",
                      background: "#fff3f3",
                      borderRadius: "8px",
                      border: "1px solid #ffdddd",
                    }}
                  >
                    {errorMessage}
                  </div>
                )}

                <Button
                  type="button"
                  className="minimal-submit-btn"
                  onClick={() => loginSeller()}
                  disabled={loading}
                >
                  Log In
                </Button>
              </Form>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SellerLogin;
